<template>
  <div class="popover-content">
    <p v-for="item in getContent"
       :key="item.bind">
      <span class="label">{{item.label}}</span>
      <span v-if="!item.event">{{getValue(item.bind)| dataListFormat}}</span>
      <span v-else>
        <el-button type="text"
                   @click="item.event(scope.row)">{{getValue(item.bind)| dataListFormat}}</el-button>
      </span>
    </p>
  </div>
</template>

<script>
import filters from "@/mixins/filters";
// popoverText组件展示多行数据的组件
export default {
  name: 'popover-content',
  props: {
    scope: Object,
    tableData: [Object, Array]
  },
  mixins: [filters],
  computed: {
    getContent () {
      return this.tableData.text.filter(item => item.hidden)
    }
  },
  methods: {
    getValue (bind) {
      return this.scope.row[bind]
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.label::after {
  content: "：";
}
.popover-content {
  line-height: 25px;
  margin-top: 3px;
  word-break: break-all;
  // white-space: nowrap;
}
</style>